import React from 'react';
import { Alert, AlertIcon, AlertTitle, AlertDescription, Box } from '@chakra-ui/react';

import { formatAlert } from '../../utils/forecasts';

const ForecastAlert = (props) => {
    const { alert } = props;
    const { severity, alertText, timeframe } = formatAlert(alert);

    // "warning" level alerts are red
    // "watch" and "advisory" levels are orange
    // https://chakra-ui.com/docs/components/alert
    const status = severity === "warning" ? "error" : "warning" ;

    return (
        <Alert
            status={status}
            mb={4}
        >
            <AlertIcon />
            <Box>
                <AlertTitle fontSize='lg'>
                    {alertText}
                </AlertTitle>
                <AlertDescription>
                    {timeframe}
                </AlertDescription>
            </Box>
        </Alert>
    );
};

export default ForecastAlert;
